import { DropDownButton } from "./DropDownButton";
import { translate } from "../../utils/translate";
import { useCallback, useMemo, useState } from "react";
import { presetsNames } from "../../utils/toolbarElements";
import { getViewPresets } from "../../utils/ganttUtils";

export function ViewPresetSelect({ onChange, api }) {
  const presetItems = useMemo(() => {
    return getViewPresets().reduce((result, i) => {
      if (presetsNames[i.id]) {
        result.push({ text: translate(presetsNames[i.id]), id: i.id });
      }
      return result;
    }, []);
  }, []);
  const [selected, setSelected] = useState("");
  const onOpen = useCallback(() => {
    setSelected(api.activeElement.viewPreset.id);
  }, [api]);
  return (
    <DropDownButton
      onOpen={onOpen}
      selected={selected}
      title={translate("Time scale")}
      onItemClick={onChange}
      items={presetItems}
      id={"preset-btn"}
      menuId="preset-btn-menu"
      dataTestid="timescale_select" //Not data-testid this is a prop passed to DropDownButton to be set there
    >
      <span className="ico icon-calendar-31" />
    </DropDownButton>
  );
}
